import { Component, OnInit } from '@angular/core';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { param } from 'jquery';
import { UserService } from '../../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import moment from 'moment';
import { FormsModule } from '@angular/forms';
import { ConfirmServiceService } from '../../confirm-dialog/confirm-service.service';
import { environment } from '../../../../environments/environment';
import { User } from '../../../models/user.model';
import { AuthService } from '../../../services/auth.service';
import { UserRoleEnum } from '../../../enums/user-role-enum';
import { formatPhoneNumber } from '../../../helpers/phone-formatter';

@Component({
  selector: 'user-list',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, FormsModule],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css',
})
export class UserListComponent implements OnInit {
  pageSize: number = 10;
  sortOrder: string = '';
  sortBy: string = '';
  page: number = 0;
  searchKey: any;
  filterQueries: any = {
    clause: {},
    order: [],
    limit: this.pageSize,
    skip: this.page * this.pageSize,
  };
  users: any = [];
  loggedUser: User = new User();
  userValidation: boolean = false;
  projectAdminRole = UserRoleEnum.ProjectAdmin;
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private readonly confirmService: ConfirmServiceService
  ) {}
  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    if (!this.loggedUser.project_id) {
      this.router.navigateByUrl(environment.DefaultRetrunUrlForMasterAdmin);
    } else if (this.loggedUser.role === UserRoleEnum.User) {
      this.userValidation = true;
    }
    this.userList();
  }

  userList() {
    let clause = {
      params: {
        project_id: this.loggedUser.project_id,
        searchKey: this.searchKey ? this.searchKey : '',
      },
    };
    this.spinner.show();

    this.userService.getUserList(clause).subscribe(
      (response) => {
        this.spinner.hide();
        this.users = response.data;
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
  onSearch() {
    this.userList();
  }
  clearFilter() {
    if (this.searchKey) {
      this.searchKey = '';
      this.userList();
    }
  }

  confirmDelete(id: any, name: any) {
    const message = `Are you sure you want to delete the user '${name}'`;
    this.confirmService.showConfirm(
      message,
      () => {
        this.deleteUser(id);
      },
      () => {}
    );
  }

  deleteUser(id: any) {
    let queryInfo = {
      params: {
        id: id,
      },
    };
    this.spinner.show();
    this.userService.markDelete(queryInfo).subscribe(
      (response: any) => {
        this.userList();
        this.toastr.success(response.message, 'User List');
      },
      (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.error, 'User List');
      }
    );
  }

  formatContactNumber(phone: string): string {
    return formatPhoneNumber(phone);
  }

  resendEmail(user: any = '') {
    const body = {
      id: user.id,
    };

    this.userService.resendUserRegistrationEmail(body).subscribe(
      (response: any) => {
        this.toastr.success(
          'User registration email sent successfully',
          'User List'
        );
      },
      (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error.error, 'User List');
      }
    );
  }
}
